import { Option } from 'components/Form/SelectCards/types';

export function getAriaLabel<T>(option: Option<T>): string | undefined {
  const { label, description } = option;

  if (typeof label === 'string') {
    return label;
  }

  if (typeof description === 'string') {
    return description;
  }

  return undefined;
}
